import { render } from "./StandAloneAccountability.vue?vue&type=template&id=ae756882&scoped=true"
import script from "./StandAloneAccountability.vue?vue&type=script&lang=js"
export * from "./StandAloneAccountability.vue?vue&type=script&lang=js"

import "./StandAloneAccountability.vue?vue&type=style&index=0&id=ae756882&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ae756882"]])

export default __exports__